<h2 mat-dialog-title>{{ titulo }}</h2>

<mat-dialog-content>

  <!-- MODO CREAR -->
  <ng-container *ngIf="data.modo === 'crear'">
    <form [formGroup]="crearForm" class="dialog-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Fecha Inicio</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="fechaInicio">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        <mat-error>Requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Fecha Fin</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="fechaFin">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        <mat-error>Requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Observaciones (opcional)</mat-label>
        <textarea matInput formControlName="observaciones" rows="3"></textarea>
      </mat-form-field>

      <p class="info-text">
        <mat-icon>info</mat-icon>
        El sistema calculará automáticamente los totales de ventas por método de pago para el período seleccionado.
      </p>
    </form>
  </ng-container>

  <!-- MODO VER -->
  <ng-container *ngIf="data.modo === 'ver'">
    <div *ngIf="loadingDetalle" class="loading-state">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <ng-container *ngIf="!loadingDetalle">
      <div class="detalle-header">
        <div class="detalle-row">
          <span class="label">Período</span>
          <span>{{ formatDate(data.corte?.fechaInicio) }} → {{ formatDate(data.corte?.fechaFin) }}</span>
        </div>
        <div class="detalle-row">
          <span class="label">Usuario</span>
          <span>{{ data.corte?.usuario?.name || data.corte?.usuario?.email || '—' }}</span>
        </div>
        <div class="detalle-row">
          <span class="label">Estado</span>
          <span class="estado-badge" [class.abierto]="data.corte?.estado === 'abierto'" [class.cerrado]="data.corte?.estado === 'cerrado'">
            {{ data.corte?.estado === 'cerrado' ? 'Cerrado' : 'Abierto' }}
          </span>
        </div>
        <div class="detalle-row" *ngIf="data.corte?.observaciones">
          <span class="label">Observaciones</span>
          <span>{{ data.corte?.observaciones }}</span>
        </div>
      </div>

      <h3>Resumen de Ventas</h3>
      <div class="totales-grid">
        <div class="total-item">
          <span class="total-label">Total Ventas</span>
          <span class="total-value primary">{{ formatCurrency(data.corte?.totalVentas) }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">Cantidad Ventas</span>
          <span class="total-value">{{ data.corte?.cantidadVentas || 0 }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">Efectivo</span>
          <span class="total-value">{{ formatCurrency(data.corte?.totalEfectivo) }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">Tarjeta</span>
          <span class="total-value">{{ formatCurrency(data.corte?.totalTarjeta) }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">Transferencia</span>
          <span class="total-value">{{ formatCurrency(data.corte?.totalTransferencia) }}</span>
        </div>
        <div class="total-item" *ngIf="data.corte?.estado === 'cerrado'">
          <span class="total-label">Efectivo Contado</span>
          <span class="total-value">{{ formatCurrency(data.corte?.efectivoContado) }}</span>
        </div>
        <div class="total-item" *ngIf="data.corte?.estado === 'cerrado'">
          <span class="total-label">Diferencia</span>
          <span class="total-value"
            [class.diff-neg]="data.corte?.diferencia < 0"
            [class.diff-pos]="data.corte?.diferencia > 0">
            {{ formatCurrency(data.corte?.diferencia) }}
          </span>
        </div>
      </div>

      <ng-container *ngIf="detalleCorte?.ventas?.length">
        <h3>Ventas del Período ({{ detalleCorte.ventas.length }})</h3>
        <div class="ventas-list">
          <div *ngFor="let v of detalleCorte.ventas" class="venta-row">
            <span class="venta-fecha">{{ v.fecha | date:'dd/MM HH:mm' }}</span>
            <span class="venta-monto">{{ v.total | currency }}</span>
            <span class="venta-estado">{{ v.estado }}</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- MODO CERRAR -->
  <ng-container *ngIf="data.modo === 'cerrar'">
    <div class="resumen-cierre">
      <div class="resumen-row">
        <span>Efectivo en sistema:</span>
        <strong>{{ formatCurrency(data.corte?.totalEfectivo) }}</strong>
      </div>
      <div class="resumen-row">
        <span>Total ventas:</span>
        <strong>{{ formatCurrency(data.corte?.totalVentas) }}</strong>
      </div>
    </div>

    <form [formGroup]="cerrarForm" class="dialog-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Efectivo Contado</mat-label>
        <span matPrefix>$ </span>
        <input matInput type="number" formControlName="efectivoContado" min="0" step="0.01" placeholder="0.00">
        <mat-error *ngIf="cerrarForm.get('efectivoContado')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="cerrarForm.get('efectivoContado')?.hasError('min')">Debe ser mayor o igual a 0</mat-error>
      </mat-form-field>

      <div *ngIf="diferenciaPreview !== null" class="diferencia-preview"
        [class.diff-neg]="diferenciaPreview < 0"
        [class.diff-pos]="diferenciaPreview > 0"
        [class.diff-zero]="diferenciaPreview === 0">
        <mat-icon>{{ diferenciaPreview < 0 ? 'trending_down' : diferenciaPreview > 0 ? 'trending_up' : 'check_circle' }}</mat-icon>
        <span>Diferencia: {{ diferenciaPreview | currency }}</span>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Observaciones (opcional)</mat-label>
        <textarea matInput formControlName="observaciones" rows="2"></textarea>
      </mat-form-field>
    </form>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">
    {{ data.modo === 'ver' ? 'Cerrar' : 'Cancelar' }}
  </button>
  <button mat-raised-button color="primary"
    *ngIf="data.modo === 'crear'"
    (click)="confirmarCrear()"
    [disabled]="crearForm.invalid || isLoading">
    <mat-spinner *ngIf="isLoading" diameter="18" style="display:inline-block;margin-right:8px"></mat-spinner>
    Crear Corte
  </button>
  <button mat-raised-button color="warn"
    *ngIf="data.modo === 'cerrar'"
    (click)="confirmarCerrar()"
    [disabled]="cerrarForm.invalid || isLoading">
    <mat-spinner *ngIf="isLoading" diameter="18" style="display:inline-block;margin-right:8px"></mat-spinner>
    Cerrar Corte
  </button>
</mat-dialog-actions>
